import type { MenuConfig } from '~typings/menu'

import permisosLogisticaPg, { RESOURCE_LOGISTICA_PG } from '@/auth/permissions/modules/logisticaPg'
import {
    ROUTE_DISTRIBUTIVO_PAGO_LOGISTICO,
    ROUTE_REPORTE_ALCANCES,
    ROUTE_REPORTE_GUIAS,
    ROUTE_VIAJES_PLANTA,
} from '@/router/routes/logistica-pg/nombres/informes'

const { informes } = permisosLogisticaPg

export default [
    {
        title: 'logistica_pg.subopciones.guia_movilizacion',
        action: informes.reporteGuias,
        resource: RESOURCE_LOGISTICA_PG,
        route: ROUTE_REPORTE_GUIAS,
    },
    {
        title: 'logistica_pg.subopciones.alcance_hielo',
        action: informes.reporteAlcances,
        resource: RESOURCE_LOGISTICA_PG,
        route: ROUTE_REPORTE_ALCANCES,
    },
    {
        title: 'logistica_pg.subopciones.reporte_viajes_planta',
        action: informes.reporteViajesPlanta,
        resource: RESOURCE_LOGISTICA_PG,
        route: ROUTE_VIAJES_PLANTA,
    },
    {
        title: 'logistica_pg.subopciones.distributivo_pago',
        action: informes.distributivoPagoLogistico,
        resource: RESOURCE_LOGISTICA_PG,
        route: ROUTE_DISTRIBUTIVO_PAGO_LOGISTICO,
    },
] as MenuConfig[]
